var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6ba66d5aee81608c0cc065e2994c5e9df3a29c02"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ecommerceberlin@eventjuicer"]={id:"6ba66d5aee81608c0cc065e2994c5e9df3a29c02"};
      